//Copied from antd/lib/date-picker/PickerTag.tsx
import React from 'react';
import { Tag } from '../tag';
export default function PickerTag(props) {
    return React.createElement(Tag, { color: 'blue', ...props });
}
